<template>
  <div id="result-table">
    <vs-table max-items="30" pagination :data="datas" no-data-text="กำลังรอข้อมูล...">
      <template slot="thead">
        <vs-th>ลำดับ</vs-th>
        <vs-th>วันที่</vs-th>
        <vs-th>เริ่มหมุน</vs-th>
        <vs-th>แสดงผล</vs-th>
        <vs-th>ผล</vs-th>
        <vs-th></vs-th>
      </template>
      <template slot-scope="{data}">
        <vs-tr :key="index" v-for="(tr, index) in data">
          <vs-td>
            {{ index+1 }}
          </vs-td>
          <vs-td>
            {{ tr.lotto_date }}
          </vs-td>
          <vs-td>
            {{ startTime(tr.start_spin) }}
          </vs-td>
          <vs-td>
            {{ startTime(tr.show_result) }}
          </vs-td>
          <vs-td>
            <strong style="color: blue">{{ tr.results | showResult }}</strong>
          </vs-td>
          <vs-td>
            <vs-button class="float-right ml-2" color="danger" icon-pack="feather" icon="icon-trash" @click="deleteData(tr.lotto_date)">ลบ</vs-button>
            <vs-button class="float-right" color="warning" icon-pack="feather" icon="icon-edit" @click="editData(tr.lotto_date)">แก้ไข</vs-button>
          </vs-td>
        </vs-tr>
      </template>
    </vs-table>
  </div>
</template>
<script>
import LottoService from "@/services/lottoService"
import moment from "moment"

export default {
  data() {
    return {
      results: []
    }
  },
  computed: {
    datas() {
      return this.results
    }
  },
  methods: {
    loadResults() {
      LottoService.getResults().then((response) => {
        this.results = response.datas
      })
    },
    deleteData(id) {
      if (confirm('ต้องการลบ?')) {
        console.log(id)
        LottoService.deleteResult(id).then((response) => {
          if (response.status === 'success') {
            this.loadResults()
            this.$vs.notify({
              title: 'สำเร็จ!',
              text: 'ลบข้อมูลเสร็จเรียบร้อย',
              iconPack: 'feather',
              icon: 'icon-alert-circle',
              color: 'success'
            });
          } else {
            this.$vs.notify({
              title: 'ผิดพลาด!',
              text: 'ลบข้อมูลไม่สำเร็จ',
              iconPack: 'feather',
              icon: 'icon-alert-circle',
              color: 'danger'
            });
          }
        })
      }
    },
    editData(id) {
      //console.log(id)
      this.$router.push({ name: 'admin-edit-results', params: { resultId: id } })
    },
    startTime(datetime) {
      if (datetime) {
        return moment(datetime).format("HH:mm")
      } else {
        return '-'
      }
    }
  },
  created() {
    this.loadResults()
  },
  filters: {
    showResult(results) {
      return results.digit5 || '-'
    }
  }
}

</script>
<style lang="scss">
#result-table {
  button.vs-button {
    padding: 0.5rem 1rem !important;
  }
}

</style>
